import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { TILE_WIDTH_DESKTOP } from '~/modules/design-board/config';

export const TopActionWrapper: StyleRule = ({ theme }) => ({
    [`& .${buttonClassName}`]: {
        width: pxToRem(32),
        height: pxToRem(32),
        borderRadius: '50%',
        background: theme.siteVariables.colors.white['300'], // use the same color as shopping cart icon
        [`& .${svgIconClassName}`]: {
            width: pxToRem(24),
            height: pxToRem(24),
        },
    },

    '& .cart-button': {
        margin: pxArrayToRem([0, 8, 0, 0]),
        [`& .${svgIconClassName}`]: {
            width: pxToRem(18),
            height: pxToRem(18),
        },
    },

    [theme.screen.laptop]: {
        width: pxToRem(TILE_WIDTH_DESKTOP),
        padding: pxArrayToRem([15, 14, 0, 13]),
        [`& .${buttonClassName}`]: {
            width: pxToRem(36),
            height: pxToRem(36),
            borderRadius: '50%',
            [`& .${svgIconClassName}`]: {
                width: pxToRem(16),
                height: pxToRem(16),
            },
        },
    },
});

export const TopActionCheckbox: StyleRule = ({ theme }) => ({
    flexGrow: 1,
    marginTop: pxToRem(4),
    [theme.screen.tablet]: {
        [`& .${svgIconClassName}`]: {
            '& path:last-child': {
                stroke: theme.siteVariables.colors.white['000'],
                strokeWidth: pxToRem(3),
            },
        },
    },
});

export const MoreButton: StyleRule = () => ({
    margin: 0,
});

export const CartButton: StyleRule = () => ({
    margin: pxArrayToRem([1, 8, 0, 0]),
    [`& .${svgIconClassName}`]: {
        width: pxToRem(17),
        height: pxToRem(17),
    },
});

export const TopActionContainer: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
});

export const PinInteractionIcons: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        display: 'inline-block',
        [`& .${buttonClassName}`]: {
            marginLeft: pxToRem(12),
        },
    },
});
